// import React, { useEffect, useState } from 'react';
import FormsyInputField from '../elements/FormsyInputField';
import { addValidationRule } from 'formsy-react';
import FormsySelect from '../elements/FormsySelect';
import FormsyCheckBox from '../elements/FormsyCheckBox';
import { useSelector } from 'react-redux';
import {
  FINANCIER_DECIMAL_LIMIT,
  FINANCIER_ID,
  PAYMENT_TYPE,
  PAYMENT_TYPE_AMOUNT_LABEL,
  TRANCHE_STATUS as TRANCHE_STATUSS,
  IF_FINSSO_BANK_OPTION
} from '../../config/constants';
import checkIcon from '../../webroot/images/icon.svg';

const CUSTOM_OPTION = {id:0,label:"Custom",value:"custom"};
const TRANCHE_STATUS = {
  "paid": "Paid",
  "on_hold": "On Hold",
  "requested": "Requested"
}

const SplitPaymentForm = (props) => {
  const {leadDocs } = useSelector(({ lead }) => ({
    leadDocs: (lead && (lead.leadDetail && (lead.leadDetail.leaddocs || [])))
  }));
  
  let { splitPaymentDetails, handleInputChange, splitPaymentFields, setSplitPaymentDetails, index, handleEditChange, handleDeleteChange, leadDetail, mainDealerFlag, setDisabledbutton, isADPCase, financierId,
    isPayViaRecoveryInitiated,
    bankOptions,
    splitBankOptions,
    trancheData,
  } = props; 

  let isPaymentProofUploaded = {
    main_dealer: leadDocs?.find(doc => doc?.doc_id === 177)?.doc_path ? true : false,
    onhold_dealer: leadDocs?.find(doc => doc?.doc_id === 177)?.doc_path ? true : false,
    split_dealer: leadDocs?.find(doc => doc?.doc_id === 178)?.doc_path ? true : false,
    split_dealer2: leadDocs?.find(doc => doc?.doc_id === 178)?.doc_path ? true : false,
    if_settlement: true
  };

  console.log(isPaymentProofUploaded,"isPaymentProofUploaded>>>>>>>>")

  addValidationRule('isValidDealerPayment', function(values, value) {
    let split_payment_amount = splitPaymentDetails.length ? splitPaymentDetails.reduce((prev, curr) => parseFloat(prev) + parseFloat(curr.amount), 0) : 0;
    let main_dealer = splitPaymentDetails.length ? parseFloat(splitPaymentDetails[0]["amount"]) : 0;
    const hasIfTranche = splitPaymentDetails?.some(p => p.payment_type === PAYMENT_TYPE.IfSettlementTranche);
    if(main_dealer <=0 && !hasIfTranche)
     return "Payment should be greater than zero";
    if(Number(value) <= 0 && value && !hasIfTranche )
     return "Amount should be greater than zero";
    if(Number(value) < 0 && value && hasIfTranche )
     return "Amount should be greater than zero";
    if(parseFloat(Math.round(split_payment_amount * 100) / 100) !== parseFloat(Math.round(values.total_payment_to_dealer * 100) / 100) && !mainDealerFlag)
      return "Sum of Split Payments should be equal to Total payment to dealer";
    else
      return true;
  });

  addValidationRule('isValidAccountNumber', function(values, value) {
    const accountNumbers = splitPaymentDetails.map(details => details.account_number);
    let bank_acc_number_match =  accountNumbers.some((accountNumber, index) => {
      return accountNumbers.indexOf(accountNumber) !== index;
    });

    if(bank_acc_number_match && !mainDealerFlag)
      return "Account number of all split payment must be different";
    else
      return true;
  });

const handleCheckboxChange = (event, index) => {
  const isChecked = event.target.checked;
  const currentPaymentType = splitPaymentDetails?.[index]?.payment_type;

  const modifiedData = splitPaymentDetails.map((data, dataIndex) => {
    const isZeroAmount = Number(data.amount || 0) === 0;

    // ✅ Current row toggle
    if (dataIndex === index) {
      return {
        ...data,
        is_tranche_marked: isChecked,
      };
    }

    // ✅ IF tranche logic (both check & uncheck)
    if (
      currentPaymentType === PAYMENT_TYPE.IfSettlementTranche &&
      isZeroAmount
    ) {
      return {
        ...data,
        is_tranche_marked: isChecked, // 🔥 key fix
      };
    }

    return data;
  });

  // existing logic
  if (
    leadDetail?.is_pushed_to_pb === "1" &&
    !splitPaymentDetails?.[index]?.is_tranche_marked
  ) {
    setDisabledbutton(!isChecked);
  }

  setSplitPaymentDetails(modifiedData);
};
const trancheStatus = leadDetail?.split_payment?.find(data => data.payment_type === trancheData?.payment_type)?.tranche_status;
  const isCheckboxChecked = () => {
    const isChecked = ['paid', 'requested'].includes(trancheStatus) || splitPaymentDetails[index]?.is_tranche_marked || splitPaymentDetails[index]?.is_tranche_marked_for_recovery;
    if (isChecked === undefined) return false;
    return isChecked;
  };
  let disableFieldsArray = ['bank_name','branch_name','account_holder_name','account_number'];
  // if(!isCheckboxMarked) disableFieldsArray = [...disableFieldsArray,'amount'];
  let disableAmountField = [PAYMENT_TYPE.MainDealer, PAYMENT_TYPE.OnHoldDealer, PAYMENT_TYPE.SplitDealer].includes(trancheData?.payment_type);

  let selectCondition = leadDetail?.is_pushed_to_pb==="1" ? (leadDetail?.is_pushed_to_pb==="1" && (!splitPaymentDetails?.[index]?.is_tranche_marked )) : false;
  const currentAmount = Number(splitPaymentDetails?.[index]?.amount || 0);
  // const isZeroAmount = currentAmount === 0;
  const isZeroAmount = currentAmount === 0 && splitPaymentDetails?.[index]?.payment_type !== PAYMENT_TYPE.SplitDealer2;
  const isDocMissing = !isPaymentProofUploaded[splitPaymentDetails?.[index]?.payment_type];
    return (
        <div className="row"> 
        { 
            <div className="col-md-12">
              <div className='split-act-btn'> 
              <FormsyCheckBox
                id="cb_pa_sameas_cra"
                name="cb_pa_sameas_cra"
                type="checkbox"
                className="custom-control-input"
                value="1"
                checked={isCheckboxChecked()}
                title={
                  isZeroAmount
                    ? "Cannot select tranche with amount 0. It will auto-select with IF tranche."
                    : isDocMissing
                    ? "Upload Proof of Payment received document for this tranche to proceed."
                    : ""
                }
                onChange={(e) => handleCheckboxChange(e,index)}
                disabled={(isPayViaRecoveryInitiated || (leadDetail?.is_pushed_to_pb==="1" && ['requested','paid'].includes(leadDetail?.split_payment?.find(split => split.payment_type === splitPaymentDetails[index]?.payment_type)?.tranche_status)) || isDocMissing || isZeroAmount)} 
              />
                <h3>{ splitPaymentDetails?.[index]?.['payment_type'] === "main_dealer" ? "Main Dealer" : splitPaymentDetails?.[index]?.['payment_type'] === "split_dealer" ? `Split Payment 1` : splitPaymentDetails?.[index]?.['payment_type'] === "onhold_dealer" ? `On Hold Dealer Payment` : splitPaymentDetails?.[index]?.['payment_type'] === "if_settlement" ? "IF Settlement Tranche" : `Split Payment 2`}</h3>
                {leadDetail?.split_payment?.length > 0 &&
                  !(trancheStatus === "requested" && Number(splitPaymentDetails?.[index]?.amount) === 0) &&
                    <span className={trancheStatus ? 'btn-primary-accent history-btn tranche-status' : ''}>
                      {TRANCHE_STATUS[trancheStatus]}
                    </span>
                  }
                {leadDetail?.split_payment?.filter(data => data.payment_type === 'split_dealer2')?.length ? null
                : splitPaymentDetails?.[index]?.['payment_type'] === "split_dealer2" ?
                  <ul className='action-btn'>
                  <li className='btn-edit' onClick={e => handleEditChange(index)}><i className="ic-edit"></i></li>
                  <li className='btn-delete' onClick={e => handleDeleteChange(index)}><i class="ic-delete-icn"></i></li>
                  </ul> : null
                }
              </div>
            </div>
        }
        {splitPaymentFields.map((field) => {
          return ((field?.dependentOn && field?.dependentValue.includes(splitPaymentDetails[index]?.[field?.dependentOn])) || !field?.dependentOn) && (
            ["text", "pattern-format", "number-format"].includes(field.type) ? (
          <fieldset class="form-filed col-md-6 ">
            <FormsyInputField
                id={"split_"+field.id}
                name={field.name}
                type={field.type}
                value={
                  splitPaymentDetails && splitPaymentDetails[index] &&
                  (
                    splitPaymentDetails[index][field.name] ??
                    (field.name === "amount" ? 0 : "")
                  )
                }
                placeholder=" "
                {...(field.type === "number-format") ? {
                  thousandsGroupStyle:"thousand",
                  thousandSeparator: ',',
                  decimalSeparator: '.'
                }: {}}
                label={field.name === "amount" ? PAYMENT_TYPE_AMOUNT_LABEL[splitPaymentDetails?.[index]?.payment_type]: field.label}
                onChange={(e) => handleInputChange(field.id, e, field.type, "split_payment", index)}
                format={field.ApplyNumberformat ? field.format : ""}
                validations={(field.name === "amount" && index !==0) ? "isValidDealerPayment" : (field.name === "account_number" && index !==0) ? "isValidAccountNumber" : field.validations}
                validationError={field.validationError}
                required={isCheckboxChecked() || (mainDealerFlag && index === 0) || (field.name === 'amount' && [PAYMENT_TYPE.SplitDealer2].includes(splitPaymentDetails?.[index]?.payment_type))}
                disabled={
                  isPayViaRecoveryInitiated || 
                  (leadDetail?.is_pushed_to_pb === "1" && !leadDetail?.title_payment?.map(data => ["requested", "on_hold", "paid"].includes(data?.tranche_status))?.length && (!splitPaymentDetails?.[index]?.is_tranche_marked) && !(trancheData?.payment_type === PAYMENT_TYPE.SplitDealer2 && field.name === 'amount' && !props?.isRegenrationCase))
                    || (index === 0 && splitPaymentDetails?.[index]?.bank_account !== CUSTOM_OPTION?.value && leadDetail?.dealerData?.[0]?.[field.name] !== null)
                    || (disableAmountField && field.name === "amount")
                    || (['on_hold'].includes(leadDetail?.split_payment?.find(split => split.payment_type === splitPaymentDetails[index]?.payment_type)?.tranche_status) && field.name === 'amount' && !props?.isRegenrationCase)
                    || (splitPaymentDetails[index]?.bank_account !== 'custom' && disableFieldsArray.includes(field.name))
                    || ['requested', 'paid'].includes(leadDetail?.split_payment?.find(split => split.payment_type === splitPaymentDetails[index]?.payment_type)?.tranche_status)
                    || (!["requested", "paid", "on_hold"].includes(splitPaymentDetails[index]?.tranche_status) && !props?.isRegenrationCase && leadDetail?.split_payment?.filter(split => split.payment_type === splitPaymentDetails[index]?.payment_type)?.length && field.name === 'amount') ? true : false
                    || (trancheData?.payment_type === PAYMENT_TYPE.IfSettlementTranche && field.name === 'amount')
                }
                isVerified={field.name === "account_number" && splitPaymentDetails?.[index]?.is_bank_verified === '1'}
                decimalScale={(Number(financierId) === FINANCIER_ID.JACCS_FINANCE && FINANCIER_DECIMAL_LIMIT.JACCS_FINANCE) || FINANCIER_DECIMAL_LIMIT.DEFAULT}
              />
          </fieldset>
          ) :
            field.type === "dropdown" ? (
              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={field.name}
                  id={field.id}
                  inputProps={{
                    options:
                    splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche
                      ? [IF_FINSSO_BANK_OPTION]:
                      leadDetail?.lead_computation_details?.finsso_transfer === "Yes" && splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.MainDealer
                        ? bankOptions?.slice(-1) // only last option for Main Dealer
                        : ([PAYMENT_TYPE.SplitDealer, PAYMENT_TYPE.SplitDealer2].includes(
                            splitPaymentDetails?.[index]?.payment_type
                          ))
                        ? [...splitBankOptions]
                            .slice(0,((splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.SplitDealer || splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.SplitDealer2) && leadDetail?.lead_computation_details?.finsso_transfer === "Yes")? -1: undefined)
                            ?.filter((data) =>
                              splitPaymentDetails
                                ?.filter((item) =>
                                  [PAYMENT_TYPE.SplitDealer, PAYMENT_TYPE.SplitDealer2].includes(
                                    item?.payment_type
                                  )
                                )
                                ?.every(
                                  (split) =>
                                    split.account_number !== data.value ||
                                    split?.payment_type === splitPaymentDetails?.[index]?.payment_type
                                )
                            )
                        : bankOptions,

                    formatOptionLabel: (data, { context }) => (
                      context === 'value' 
                        ? data.label 
                        : (
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {data.label}
                            {data.is_bank_verified === '1' && <img src={checkIcon} style={{ width: '15px', height: '15px' }} alt="verified" />}
                          </span>
                        )
                    ),
                    placeholder: field.label,
                    className: "react-select",
                    classNamePrefix: "react-select",

                    value:
                    splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche
                      ? IF_FINSSO_BANK_OPTION:
                      leadDetail?.lead_computation_details?.finsso_transfer === "Yes" && splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.MainDealer ? bankOptions?.slice(-1): [
                            ...splitBankOptions,
                            ...(
                              [TRANCHE_STATUSS.requested, TRANCHE_STATUSS.paid].includes(
                                splitPaymentDetails?.[index]?.tranche_status
                              )
                                ? [CUSTOM_OPTION]
                                : []
                            ),
                          ].filter(({ value }) =>
                            splitPaymentDetails?.[index]?.bank_account?.includes(value)
                          ),
                    isDisabled:
                     splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche
                        ? true:
                      leadDetail?.lead_computation_details?.finsso_transfer === "Yes" && splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.MainDealer ? true
                        : isPayViaRecoveryInitiated ||
                          (['requested', 'paid'].includes(
                            leadDetail?.split_payment?.find(
                              (split) =>
                                split.payment_type === splitPaymentDetails[index]?.payment_type
                            )?.tranche_status
                          ) ||
                          selectCondition
                            ? true
                            : false) ||
                          (isADPCase && index === 1 && leadDetail?.lead_computation_details?.finsso_transfer === "No"),
                  }}
                  value={splitPaymentDetails[index]?.[field?.name]}
                  onChange={(e) => handleInputChange(field.id, e, field.type, "split_payment", index)}
                  required={isCheckboxChecked() || (mainDealerFlag && index === 0)}
                />

              </fieldset>
              ) : null
        )})}
        
      </div>
    );
}
export default SplitPaymentForm;